import { PdfEntityByAcademicYearList } from 'components/pdfStudent';
import { splitEntitiesByAcademicYear } from 'containers/pdfStudent/utils/splitEntitiesByAcademicYear';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetCivilClubs } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { civilClubsSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';

const PdfCivilClubContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const civilClubs = useAppSelector(civilClubsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().civilClubs });

  const hasData = civilClubs.content.length > 0;
  const academicYearData = splitEntitiesByAcademicYear(civilClubs, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Клубы" Icon={IconWidgetCivilClubs}>
      {hasData && <PdfEntityByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfCivilClubContainer;
